import { SORBET } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { UPGRADE_POPOVER_CONTENT_I18N_KEYS } from './constants';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UpgradePopoverBody = ({
  upgradeKey
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Text, {
      as: "h7",
      marginBlockEnd: "200",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "upgrade",
        color: SORBET,
        className: "m-right-1"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.upgradePopover.upgradePoints.${UPGRADE_POPOVER_CONTENT_I18N_KEYS[upgradeKey]}.title`
      })]
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.upgradePopover.upgradePoints.${UPGRADE_POPOVER_CONTENT_I18N_KEYS[upgradeKey]}.content`
      })
    })]
  });
};
export default UpgradePopoverBody;